import React, { useEffect, useState } from 'react';
import './styles.css';
import Popup from './Popup';

function PopupButton({ popups }) {
  const [popup, setPopup] = useState(null);
  const handleClick = (event) => {
    const triggeredPopup = popups?.filter((popup) =>
      event.target.matches(popup?.triggers?.[0]?.trigger_class)
    )?.[0];

    if (triggeredPopup) {
      openModal(triggeredPopup);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [handleClick]);

  const closeModal = () => {
    document.addEventListener('click', handleClick);
    setPopup(null);
  };

  const openModal = (triggeredPopup) => {
    document.removeEventListener('click', handleClick);
    setPopup(triggeredPopup);
  };

  return (
    <>{popup && <Popup popup={popup ?? null} closeModal={closeModal} />}</>
  );
}

export default PopupButton;
window.__Components.PopupButton = PopupButton;
